import theme from "../../../styles/theme"
import { ResponsiveBar } from "@nivo/bar"
import React from 'react'

const ChartStaticInspect = (param) => {
    return (
          <ResponsiveBar
              theme={{fontSize: '1rem'}}
              data={param.row.chart}
              keys={[
                  'complete',
              ]}
              margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
              padding={0.2}
              innerPadding={3}
              layout="horizontal"
              valueScale={{ type: 'symlog' }}
              indexScale={{ type: 'band', round: true }}
              colors={[theme.color.secondary.puppleB,theme.color.secondary.blueB,theme.color.secondary.greenB]}
              borderColor={{ theme: 'background' }}
              axisTop={null}
              axisRight={null}
              axisBottom={null}
              axisLeft={{
                  tickSize: 2,
                  tickPadding: 2,
                  tickRotation: 0,
                  legendOffset: -40
              }}
            //   minValue={-100}
              maxValue={100}
              enableGridY={false}
              labelSkipWidth={12}
              labelSkipHeight={12}
              labelTextColor={'#333333'}
              tooltip={()=>{return false}}
          />
    )
}

export default ChartStaticInspect;